import React, { useEffect } from 'react';

import CustomTd from '../shared/table/CustomTd';
import DeleteButton from '../shared/buttons/DeleteButton';
import ListView from '../shared/lists/ListView';
import SelectList from '../shared/inputs/SelectList';
import useAutoCollection from '../../utilities/useAutoCollection';

//SALES APPOINTMENT Area List
const AreaList = ({
    disabled,
    formChange,
    items,
    salesAppointmentId
}) => {
    const setData = (data) =>
        formChange({ target: { name: 'areasInterestedIn', value: data } });

    const newItem = {
        id: 0,
        salesAppointmentId: salesAppointmentId,
        areaTypeId: 0,
        newItem: true
    };

    const { itemChange, itemDelete } = useAutoCollection(items, setData, !disabled, newItem);

    const tableHead = (
        <thead className="d-none">
        </thead>
    );

    const getItems = () => {
        const keyedItems = items.filter(item => item.reactKey !== undefined);
        return keyedItems.map((item, index) =>
        (
            <tr key={item.reactKey}>
                <CustomTd className="border-0">
                    <SelectList
                        onChange={(e) => itemChange(e, index)}
                        lookupType="AreaType"
                        name={`areasInterestedIn[${index}].areaTypeId`}
                        placeholder="Areas Interested In"
                        required={!item.newItem}
                        validationError={item.areaTypeId_error}
                        value={item.areaTypeId}
                        disabled={disabled}
                    />
                </CustomTd>
                <CustomTd width="45px" className="border-0 button-cell">
                    <div className="button-wrapper d-inline-block">
                        <DeleteButton
                            confirmDelete={false}
                            onClick={() => itemDelete(index)}
                            showText={false}
                            disabled={disabled || item.areaTypeId === 0} />
                    </div>
                </CustomTd>
            </tr>
        ));
    }

    return (
        <ListView
            canAdd={false}
            className="child-list"
            itemName="Area"
            items={getItems()}
            tableHead={tableHead}
        />
    );
}

export default AreaList;